import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, SwipeableDrawer, useTheme } from '@mui/material';
import { noop } from 'lodash';
import React from 'react';
import { IAudit } from 'types/audits';
import { ITheme } from 'types/theme';
import AuditCard from './AuditCard';

interface IAuditDrawerProps {
	audit?: IAudit;
	onClose: () => void;
}

const AuditDrawer: React.FC<IAuditDrawerProps> = ({ audit, onClose }) => {
	const theme = useTheme<ITheme>();

	return (
		<SwipeableDrawer
			anchor="right"
			open={!!audit}
			onOpen={noop}
			onClose={onClose}
			hideBackdrop
			variant="persistent"
			sx={{
				// The following will apply on top level paper inside
				// Because Mui drawer is build that way
				'&>div': {
					boxShadow: 2
				}
			}}
		>
			<Box
				display="flex"
				flexGrow={1}
				flexDirection="column"
				pt={0.5}
				pl={2}
				width={{
					xs: 260,
					sm: 450
				}}
				sx={{
					backgroundColor: theme.palette.layout.background
				}}
			>
				<Box>
					<IconButton
						onClick={onClose}
						aria-label={intl.tr('button.close')}
						data-testid="close-audit-drawer"
					>
						<CloseIcon />
					</IconButton>
				</Box>
				{audit && <AuditCard audit={audit} />}
			</Box>
		</SwipeableDrawer>
	);
};

AuditDrawer.defaultProps = {
	audit: undefined
};

export default AuditDrawer;
